<template>
<div class="row" style='margin-top:25px'>
  <div class="col-sm-12">
    <div class="form-group">
      <label class="control-label">Titre * </label>
      <input v-model="name" type="text" class="form-control" >
      <label class="error" v-if="errors.name">{{ errors.name }}</label>
    </div>
  </div>

  <div class="col-sm-6" style='margin-top:25px'>
    <div class="form-group">
      <strong class="control-label">Type de dossier</strong><br>
      <select v-model="dossier_type" class="form-control">
        <option v-for="option in dossier_types" :value="option.key"
          :key="option.key">
          {{ option.name }}
        </option>
      </select>
    </div>
  </div>

  <div class="col-sm-12" style='margin-top:25px;margin-bottom:25px'>
    <div class="form-group">
      <label class="control-label">Description</label>
      <trumbowyg
        :config="config"
        class="form-control"
        id="textarea"
        v-model="description"
        rows="5"
        max-rows="6"
      ></trumbowyg>
      <label class="error" v-if="errors.description">{{ errors.description }}</label>
    </div>
  </div>
  

  <div class="col-sm-12">
    <button class="btn btn-primary" v-on:click="save">Enregistrer</button>&nbsp;
    <button class="btn btn-default" v-on:click="back" >Retour</button>
  </div>
</div>

</template>

<script>
import axios from 'axios';

import {en, fr} from 'vuejs-datepicker/dist/locale'

export default {
  data: function() {return {
    designation_dossier_id:0,
    serviceprovider:{},
    dossier_types:{},
    dossier_type:'',
    name:'',
    description:'',
    errors:{name:'',effective_at:'',description:''},
    messages:{},
    config: this.$trumbowygConfig,
  }},
  name: 'ServiceProviderDossierCreation',
  methods: {

    refresh: function() {
      axios
        .get(this.$root.$data.server_base + '/api/service_provider_dossier.php',
          { params: {dossier_id:this.designation_dossier_id,service_provider_id: this.$route.params.service_provider_id}})
        .then(response => (this.$checkApiErrors(response.data),this.serviceprovider = response.data.serviceprovider,this.dossier_types = response.data.dossier_types))
    },
    back: function()
    {
      this.$router.go(-1);
    },

    save: function()
    {
      var empty_field = false;

      if(this.name == '')
      {
        this.errors.name = this.$messages.required;
        empty_field = true;
      }
      else
        this.errors.name = '';

      if(!empty_field)
      {
        let data = {
          dossier_id:this.designation_dossier_id,
          name:this.name,
          description:this.description,
          dossier_type:this.dossier_type,
          service_provider_id:this.$route.params.service_provider_id

        }
        axios
          .post(this.$root.$data.server_base + '/api/designation_dossier_save.php',
            data,
            {headers:{
                'Content-Type': 'application/json',
          }})
          .then(response => {
            this.$checkApiErrors(response.data);
            this.$router.push({name:'dossiers', params: {
              service_provider_id: this.$route.params.service_provider_id}});

          })
      }
    },

  },
  mounted () {
    this.refresh();
    this.messages = this.$root.$data.messages;

  }
}
</script>
